
package org.hs_soft.runmynesto.pages.home.sub_page.customer_card.components.tabs.customer_card_tab.component.periods

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.margin
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.model.general.ButtonTypes
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.customer_card.loyalty_card_detail.LoyaltyCardDetail
import org.hs_soft.runmynesto.domain.model.home.customer_card.tabs.card.PeriodDaysEnum
import org.hs_soft.runmynesto.domain.model.home.customer_card.tabs.card.PeriodMonthEnum
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.MediumContentTitle
import org.hs_soft.runmynesto.pages.components.dialog.component.CustomButton
import org.hs_soft.runmynesto.pages.home.sub_page.customer_card.components.tabs.customer_card_tab.component.periods.component.PeriodDays

@Composable
fun Period(
    windowSizeMode: WindowSizeModeEnum,
    filterLoyaltyCardsLoading:Boolean,
    selectedPeriodType: PeriodDaysEnum?,
    selectedLoyaltyCard: LoyaltyCardDetail?,
    selectedPeriodMonthType: PeriodMonthEnum?,
    onSelectDaysPeriodType: (PeriodDaysEnum) -> Unit,
    filterCardItems:(PeriodDaysEnum?)->Unit,

    )
{
    LaunchedEffect(selectedLoyaltyCard){
        onSelectDaysPeriodType(
            PeriodDaysEnum.TODAY
        )
    }
    Column(
        modifier = Modifier
            .margin(top=Dimen.normalPadding)
    ) {
        MediumContentTitle(
            title = Strings.current().period,
        )

        PeriodDays(
            windowSizeMode=windowSizeMode,
            selectedPeriodType=selectedPeriodType,
            onSelectPeriodType={
                onSelectDaysPeriodType(it)
            }
        )

//    PeriodsYear(
//        windowSizeMode = windowSizeMode
//    )
//
//    PeriodsMonth(
//        selectedPeriodType = selectedPeriodMonthType,
//        onSelectPeriodType = {
//
//        }
//    )
//
//    CustomDate(
//
//    )

        CustomButton(
            modifier = Modifier
                .margin(
                    topBottom = Dimen.normalPadding,
                ),
            loading = filterLoyaltyCardsLoading,
            windowSizeMode=windowSizeMode,
            title = Strings.current().calculate,
            buttonType = ButtonTypes.CONTAINED,
            onButtonClick = {
                filterCardItems(selectedPeriodType)
            }

        )

    }


}



